/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ProcessingStatusType } from './ProcessingStatusType.js';
import {
    ProcessingStatusTypeFromJSON,
    ProcessingStatusTypeFromJSONTyped,
    ProcessingStatusTypeToJSON,
} from './ProcessingStatusType.js';

/**
 * 
 * @export
 * @interface ContactV2
 */
export interface ContactV2 {
    /**
     * 
     * @type {number}
     * @memberof ContactV2
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactV2
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactV2
     */
    customerPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactV2
     */
    systemPhoneNumber?: string;
    /**
     * 
     * @type {ProcessingStatusType}
     * @memberof ContactV2
     */
    processingStatus?: ProcessingStatusType;
    /**
     * 
     * @type {string}
     * @memberof ContactV2
     */
    agentName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactV2
     */
    audioUri?: string;
    /**
     * 
     * @type {number}
     * @memberof ContactV2
     */
    agentUserId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ContactV2
     */
    dateStarted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContactV2
     */
    dateEnded?: Date;
}

/**
 * Check if a given object implements the ContactV2 interface.
 */
export function instanceOfContactV2(value: object): boolean {
    return true;
}

export function ContactV2FromJSON(json: any): ContactV2 {
    return ContactV2FromJSONTyped(json, false);
}

export function ContactV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'customerPhoneNumber': json['customerPhoneNumber'] == null ? undefined : json['customerPhoneNumber'],
        'systemPhoneNumber': json['systemPhoneNumber'] == null ? undefined : json['systemPhoneNumber'],
        'processingStatus': json['processingStatus'] == null ? undefined : ProcessingStatusTypeFromJSON(json['processingStatus']),
        'agentName': json['agentName'] == null ? undefined : json['agentName'],
        'audioUri': json['audioUri'] == null ? undefined : json['audioUri'],
        'agentUserId': json['agentUserId'] == null ? undefined : json['agentUserId'],
        'dateStarted': json['dateStarted'] == null ? undefined : (new Date(json['dateStarted'])),
        'dateEnded': json['dateEnded'] == null ? undefined : (new Date(json['dateEnded'])),
    };
}

export function ContactV2ToJSON(value?: ContactV2 | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'sourceId': value['sourceId'],
        'customerPhoneNumber': value['customerPhoneNumber'],
        'systemPhoneNumber': value['systemPhoneNumber'],
        'processingStatus': ProcessingStatusTypeToJSON(value['processingStatus']),
        'agentName': value['agentName'],
        'audioUri': value['audioUri'],
        'agentUserId': value['agentUserId'],
        'dateStarted': value['dateStarted'] == null ? undefined : ((value['dateStarted']).toISOString()),
        'dateEnded': value['dateEnded'] == null ? undefined : ((value['dateEnded']).toISOString()),
    };
}

